import React from 'react';
import {ViewStyle, StyleProp} from 'react-native';
import globalStore from '@/services/global.state';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';

const Wallet = ({style}: {style?: StyleProp<ViewStyle>}) => {
  const LottieView = require('lottie-react-native').default;
  const lottieRef = React.useRef<typeof LottieView>(null);
  const {calcActualSize} = useScreenSize();
  React.useEffect(() => {
    const sub = globalStore.amountChanged.subscribe(res => {
      if (res.last !== null) {
        if (res.last < res.current && res.current !== globalStore.userAmount) {
          lottieRef.current?.play();
        }
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);
  const lottieStyle = {
    height: calcActualSize(76),
    width: calcActualSize(76),
  };
  return (
    <LottieView
      ref={lottieRef}
      style={[lottieStyle, style]}
      source={require('./wallet-animation-config.json')}
      loop={false}
      autoPlay={false}
      imageAssetsFolder={'lottie'}
    />
  );
};

export default Wallet;
